import { MultiVoucherUsageFunnel } from 'app/src/features/Shopping/Direct/MultiVoucherUsage/components/MultiVoucherUsageFunnel'
import { refundApi } from 'app/src/services/welfareportal'
import { ErrorPage, PageWidget } from 'app/src/shared/components'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export function MultiVoucherUsage() {
  const params = useParams()
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.MultiVoucher.Usage.Request' })

  const refundGetResponse = refundApi.useRefundRequestGet({
    pathParams: { refundId: params['id']! },
  })
  return (
    <PageWidget containerClassNamesOverrides='refundfunnel'>
      {refundGetResponse.isLoading || refundGetResponse.isFetching ? (
        <>
          <h1 className='welfareportal-titlecenter'>{t('loadingInProgressTitle')}</h1>
          <div className='mt-20 flex'>
            <div className='mx-auto'>
              <ProgressSpinner data-testid='loading-element' className='flex' />
              {t('loadingInProgressDescription') && (
                <div className='mt-4' dangerouslySetInnerHTML={{ __html: t('loadingInProgressDescription') }} />
              )}
            </div>
          </div>
        </>
      ) : refundGetResponse.isError || !refundGetResponse?.data || refundGetResponse.data.status.value !== 'DRAFT' ? (
        <ErrorPage
          errorMessage={refundGetResponse.error?.status == 404 ? t('notFoundMessage') : t('loadingInProgressErrorMessage')}
        />
      ) : (
        <MultiVoucherUsageFunnel refund={refundGetResponse.data} />
      )}
    </PageWidget>
  )
}
